import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { stringUtil } from "../../utilities/string";

var requestSchema = yup.object({
  appointmentId: yup.number().required(),
  charge: yup.boolean(),
});

export function useMarkAppointmentAsNoShowMutation(options = {}) {
  var queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      var req = requestSchema.validateSync(dto, {
        strict: true,
      });

      const notification = {
        notification_type: req.notification.type,
        notification_body: stringUtil.toBase64(req.notification.body),
        appointment_sms: stringUtil.toBase64(req.notification.bodySms),
        appointment_subject: req.notification.subject,
        success_msg: req.notification.successMessage,
      };

      return http.post(
        HTTP_ENDPOINTS.appointments.markAsNoShow(req.appointmentId),
        {
          pat_to_be_charged: req.isAdditionalProvider ? false : req.charge,
          appointment_id: req.appointmentId,
          ...notification,
        },
      );
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.appointments.appointment],
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
